module.exports = __webpack_public_path__ + "static/media/megaphone.545fa537.svg";